function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { styled } from '@mui/material/styles';
import InfoIcon from '@pixel/assets/icons/Info';
import SuccessIcon from '@pixel/assets/icons/Success';
import ErrorIcon from '@pixel/assets/icons/Error';
import WarningIcon from '@pixel/assets/icons/Warning';
import Typography from '../Typography';
import Box from '../Box';
const PREFIX = 'StatusMessage';
const classes = {
  root: "".concat(PREFIX, "-root"),
  icon: "".concat(PREFIX, "-icon"),
  iconContainer: "".concat(PREFIX, "-iconContainer"),
  textContainer: "".concat(PREFIX, "-textContainer"),
  contained: "".concat(PREFIX, "-contained"),
  contained_success: "".concat(PREFIX, "-contained_success"),
  contained_error: "".concat(PREFIX, "-contained_error"),
  contained_info: "".concat(PREFIX, "-contained_info"),
  contained_warning: "".concat(PREFIX, "-contained_warning"),
  inline_success: "".concat(PREFIX, "-inline_success"),
  inline_error: "".concat(PREFIX, "-inline_error"),
  inline_info: "".concat(PREFIX, "-inline_info"),
  inline_warning: "".concat(PREFIX, "-inline_warning"),
  hideBorder: "".concat(PREFIX, "-hideBorder")
};
const Root = styled('div')(_ref => {
  let {
    theme
  } = _ref;
  return {
    ["&.".concat(classes.root)]: {
      display: 'flex',
      flexFlow: 'row',
      padding: theme.spacing(0),
      borderRadius: theme.shape.borderRadius
    },
    ["&.".concat(classes.icon)]: {},
    ["&.".concat(classes.iconContainer)]: {
      display: 'inline-flex',
      lineHeight: '1rem',
      paddingRight: theme.spacing(1)
    },
    ["&.".concat(classes.textContainer)]: {
      display: 'inline-flex',
      flexGrow: 1
    },
    ["&.".concat(classes.contained)]: {
      padding: theme.spacing(1)
    },
    ["&.".concat(classes.contained_success)]: {
      backgroundColor: theme.palette.success.softBackground,
      color: theme.palette.success.softContrastText,
      border: "solid 1px ".concat(theme.palette.success.softContrastText)
    },
    ["&.".concat(classes.contained_error)]: {
      backgroundColor: theme.palette.error.softBackground,
      color: theme.palette.error.softContrastText,
      border: "solid 1px ".concat(theme.palette.error.softContrastText)
    },
    ["&.".concat(classes.contained_info)]: {
      color: theme.palette.info.softContrastText,
      backgroundColor: theme.palette.info.softBackground,
      border: "solid 1px ".concat(theme.palette.info.softBackground)
    },
    ["&.".concat(classes.contained_warning)]: {
      backgroundColor: theme.palette.warning.softBackground,
      color: theme.palette.warning.softContrastText,
      border: "solid 1px ".concat(theme.palette.warning.softContrastText)
    },
    ["&.".concat(classes.inline_success)]: {
      color: theme.palette.mode === 'light' ? theme.palette.success.dark : theme.palette.success.light
    },
    ["&.".concat(classes.inline_error)]: {
      color: theme.palette.mode === 'light' ? theme.palette.error.dark : theme.palette.error.light
    },
    ["&.".concat(classes.inline_info)]: {
      color: theme.palette.mode === 'light' ? theme.palette.info.dark : theme.palette.info.light
    },
    ["&.".concat(classes.inline_warning)]: {
      color: theme.palette.mode === 'light' ? theme.palette.warning.dark : theme.palette.warning.light
    },
    ["&.".concat(classes.hideBorder)]: {
      border: 'none'
    }
  };
});
export const Variants = {
  Inline: "inline",
  Contained: "contained"
};
const VariantsValues = Object.keys(Variants).map(key => Variants[key]);
const StatusMessage = _ref2 => {
  let {
    type = "info",
    variant = "inline",
    typographyVariant = "body1",
    hideBorder = false,
    hideIcon = false,
    className,
    children,
    ...restProps
  } = _ref2;
  const types = ['error', 'warning', 'success', 'info'];
  const iconMap = {
    error: ErrorIcon,
    warning: WarningIcon,
    success: SuccessIcon,
    info: InfoIcon
  };
  const validType = types.indexOf(type) >= 0 ? type : 'info';
  const validVariant = VariantsValues.indexOf(variant) >= 0 ? variant : 'inline';
  const Icon = iconMap[validType];
  const rootClasses = [classes.root, className];
  rootClasses.push(classes["".concat(validVariant, "_").concat(validType)]);
  // console.log(rootClasses);
  if (validVariant !== 'inline') {
    rootClasses.push(classes.contained);
  }
  if (hideBorder === true) {
    rootClasses.push(classes.hideBorder);
  }
  //set variant for typography
  const variantType = typographyVariant || 'body1';
  return /*#__PURE__*/React.createElement(Root, _extends({
    className: rootClasses.join(' ')
  }, restProps), !hideIcon && /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'inline-flex',
      lineHeight: '1rem',
      paddingRight: 1
    },
    className: classes.iconContainer
  }, /*#__PURE__*/React.createElement(Icon, {
    color: "inherit",
    className: [classes.icon, 'status_icon'].join(' ')
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.textContainer
  }, /*#__PURE__*/React.createElement(Typography, {
    component: "div",
    color: "inherit",
    "aria-label": children,
    variant: variantType
  }, children)));
};
export default StatusMessage;